export const styleFn = (offset: number, height: number) => ({
  height: `calc(${height - offset}px)`,
  'overflow-y': 'auto',
});
